import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getclient_projectsHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "clientprojects", ...action.payload }),
		);
		yield put({
			type: types.GET_CLIENT_PROJECTS_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_CLIENT_PROJECTS_ERROR,
			payload,
		});
	}
}

export function* getclient_projectsWatcherSaga() {
	yield takeLatest(
		types.GET_CLIENT_PROJECTS_START,
		getclient_projectsHandlerSaga,
	);
}

//create

//delete

function* deleteclient_projectsHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("clientprojects", action.payload),
		);
		yield put({
			type: types.DELETE_CLIENT_PROJECTS_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_CLIENT_PROJECTS_ERROR,
			payload,
		});
	}
}

export function* deleteclient_projectsWatcherSaga() {
	yield takeLatest(
		types.DELETE_CLIENT_PROJECTS_START,
		deleteclient_projectsHandlerSaga,
	);
}

//update
